import React from 'react';

import { useTheme } from '@mui/material/styles';

// SVG 아이콘들을 React 컴포넌트로 래핑
export const IcAdd = ({ color = 'currentColor', size = 24, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ '--icon-color': color }}
        {...props}
    >
        <path
            d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z"
            fill="var(--icon-color)"
        />
    </svg>
);

export const FitnessHexagon = ({ color = '#00BFFF', size = 101, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 101 100"
        fill="none"
        xmlns="httddf://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M50.5 0L93.8013 25V75L50.5 100L7.19873 75V25L50.5 0Z"
            fill={color}
            fillOpacity="0.1"
        />
        <path
            d="M50.5001 10.7144L84.5225 30.3572V69.6429L50.5001 89.2858L16.4776 69.6429V30.3572L50.5001 10.7144Z"
            fill={color}
            fillOpacity="0.1"
        />
        <path
            d="M50.5001 21.4285L75.2437 35.7142V64.2856L50.5001 78.5713L25.7566 64.2856V35.7142L50.5001 21.4285Z"
            fill={color}
            fillOpacity="0.1"
        />
        <path
            d="M50.5002 32.1428L65.965 41.0714V58.9285L50.5002 67.8571L35.0355 58.9285V41.0714L50.5002 32.1428Z"
            fill={color}
            fillOpacity="0.1"
        />
        <path
            d="M50.4998 42.8572L56.6857 46.4286V53.5715L50.4998 57.1429L44.3139 53.5715V46.4286L50.4998 42.8572Z"
            fill={color}
            fillOpacity="0.1"
        />
    </svg>
);

export const Favorite = ({
    color,
    size = 20,
    opacity = 0.6,
    ...props
}) => {
    const theme = useTheme();
    const finalColor = color || theme?.palette?.figma?.icon;
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_1_923)">
                <path
                    opacity={opacity}
                    d="M11.0341 2.08913L13.4136 6.14303L18.0535 7.12716C18.9503 7.31677 19.3072 8.39119 18.6941 9.05931L15.5185 12.5444L16.0035 17.2032C16.095 18.1061 15.1707 18.7652 14.3379 18.395L10 16.499L5.66211 18.395C4.82016 18.7652 3.89584 18.0971 3.99651 17.2032L4.48155 12.5444L1.30592 9.05931C0.692756 8.39119 1.04967 7.31677 1.94653 7.12716L6.58643 6.14303L8.96586 2.08913C9.42344 1.30362 10.5674 1.30362 11.025 2.08913H11.0341Z"
                    stroke={finalColor}
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1_923">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
};

export const FavoriteCheck = ({
    color,
    size = 20,
    ...props
}) => {
    const theme = useTheme();
    const finalColor = color || theme?.palette?.figma?.icon;
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_1_924)">
                <path
                    d="M11.0341 2.08913L13.4136 6.14303L18.0535 7.12716C18.9503 7.31677 19.3072 8.39119 18.6941 9.05931L15.5185 12.5444L16.0035 17.2032C16.095 18.1061 15.1707 18.7652 14.3379 18.395L10 16.499L5.66211 18.395C4.82016 18.7652 3.89584 18.0971 3.99651 17.2032L4.48155 12.5444L1.30592 9.05931C0.692756 8.39119 1.04967 7.31677 1.94653 7.12716L6.58643 6.14303L8.96586 2.08913C9.42344 1.30362 10.5674 1.30362 11.025 2.08913H11.0341Z"
                    fill={finalColor}
                    fillOpacity="1"
                />
            </g>
            <defs>
                <clipPath id="clip0_1_924">
                    <rect width="20" height="20" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
};

export const Lock = ({ color = 'white', size = 16, ...props }) => (
    <svg
        width={size}
        height={(size * 19) / 16}
        viewBox="0 0 16 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M12.6875 8.62378H3.3125C1.7592 8.62378 0.5 9.89423 0.5 11.4614V16.1719C0.5 17.739 1.7592 19.0095 3.3125 19.0095H12.6875C14.2408 19.0095 15.5 17.739 15.5 16.1719V11.4614C15.5 9.89423 14.2408 8.62378 12.6875 8.62378Z"
            fill={color}
        />
        <path
            d="M3.41565 9.18187V6.57125C3.41565 4.02685 5.47815 1.94592 8.00002 1.94592C10.5219 1.94592 12.5844 4.02685 12.5844 6.57125V9.18187"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const Unlock = ({ color = 'white', size = 16, ...props }) => (
    <svg
        width={size}
        height={(size * 18) / 16}
        viewBox="0 0 16 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_264_12491)">
            <path
                d="M12.69 7.48999H3.31C1.76 7.48999 0.5 8.74999 0.5 10.3V14.97C0.5 16.52 1.76 17.78 3.31 17.78H12.68C14.23 17.78 15.49 16.52 15.49 14.97V10.3C15.49 8.74999 14.23 7.48999 12.68 7.48999H12.69Z"
                fill={color}
            />
            <path
                d="M3.32999 8.65L3.04999 6.08001C2.77999 3.57001 4.60999 1.30001 7.11999 1.03001C9.27999 0.800005 11.26 2.12001 11.94 4.09001"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_264_12491">
                <rect width="15" height="17.79" fill="white" transform="translate(0.5)" />
            </clipPath>
        </defs>
    </svg>
);

export const Tournament = ({ color = 'white', size = 18, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_259_12135)">
            <path
                d="M15.42 5.68005L16.25 7.18005L17.93 7.50005L16.76 8.75005L16.97 10.4401L15.42 9.71005L13.87 10.4401L14.09 8.75005L12.92 7.50005L14.6 7.18005L15.42 5.68005Z"
                fill={color}
            />
            <path
                d="M1 1H5.13V6.35H1M5.13 13.76H8.95V3.68H5.13M1 16.44H5.13V11.09H1M8.95 8.78H12.07"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_259_12135">
                <rect width="17.93" height="17.44" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export const Ranking = ({ color = 'white', size = 20, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M12.35 9.34H7.64C7.3 9.34 7.01 9.62 7.01 9.97V17.36H12.97V9.97C12.97 9.63 12.69 9.34 12.34 9.34H12.35ZM11.33 7.6C11.33 8.23 10.94 8.52 10.4 8.52C9.86 8.52 9.47 8.23 9.47 7.6V4.64H8.5C8.05 4.64 7.83 4.41 7.83 4C7.83 3.54 7.98 3.41 8.7 3.29C9.25 3.19 9.53 2.94 9.76 2.61C10.05 2.21 10.23 2 10.59 2C11.05 2 11.32 2.2 11.32 2.63V7.6H11.33ZM5.84 11.4H1.63C1.29 11.4 1 11.68 1 12.03V17.34H6.46V12.03C6.46 11.69 6.18 11.4 5.83 11.4H5.84ZM5.08 10.63H2.36C2.01 10.63 1.79 10.36 1.79 10.08C1.79 9.67 1.89 9.45 3.11 8.6L3.74 8.16C4.07 7.93 4.19 7.75 4.19 7.47C4.19 7.14 3.97 6.93 3.61 6.93C2.85 6.93 3.24 7.86 2.49 7.86C2.01 7.86 1.84 7.59 1.84 7.21C1.84 6.57 2.47 5.89 3.65 5.89C5.07 5.89 5.56 6.66 5.56 7.4C5.56 7.96 5.28 8.36 4.69 8.73L3.48 9.49L5.06 9.5C5.46 9.5 5.63 9.71 5.63 10.06C5.63 10.41 5.46 10.62 5.06 10.62L5.08 10.63ZM18.37 13.15H14.16C13.82 13.15 13.53 13.43 13.53 13.78V17.35H18.99V13.78C18.99 13.44 18.71 13.15 18.36 13.15H18.37ZM16.14 12.32C15.13 12.32 14.48 11.77 14.48 11.21C14.48 10.86 14.7 10.6 15.06 10.6C15.74 10.6 15.4 11.37 16.1 11.37C16.54 11.37 16.75 11.21 16.75 10.79C16.75 10.47 16.59 10.4 16.33 10.38C15.91 10.35 15.76 10.2 15.76 9.98C15.76 9.64 15.98 9.54 16.28 9.54C16.5 9.54 16.72 9.41 16.72 9.12C16.72 8.8 16.46 8.69 16.13 8.69C15.89 8.69 15.76 8.77 15.57 9.05C15.44 9.25 15.32 9.31 15.13 9.31C14.74 9.31 14.57 9.01 14.57 8.75C14.57 8.2 15.19 7.74 16.29 7.74C17.27 7.74 17.95 8.22 17.95 8.99C17.95 9.41 17.76 9.73 17.41 9.85C17.84 10 18.06 10.36 18.06 10.81C18.06 11.39 17.76 12.33 16.14 12.33V12.32Z"
            fill={color}
        />
    </svg>
);

export const IcMenu = ({
    color,
    size = 20,
    ...props
}) => {

    const theme = useTheme();
    const finalColor = color || theme?.palette?.figma?.icon;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect x="1" y="6" width="18" height="2" rx="1" fill={finalColor} />
            <rect x="1" y="10" width="18" height="2" rx="1" fill={finalColor} />
            <rect x="1" y="14" width="18" height="2" rx="1" fill={finalColor} />
        </svg>
    );
};

export const IcAlarm = ({ color = 'currentColor', size = 20, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <path
            d="M1.82671 15.7C1.6089 15.5133 1.5 15.2683 1.5 14.9688C1.5 14.5059 1.6828 14.0664 2.04841 13.6541C2.41402 13.238 2.7913 12.8296 3.17636 12.4251C3.39417 12.1917 3.56141 11.8922 3.6781 11.5227C3.79478 11.1532 3.87646 10.7565 3.92702 10.3325C3.97758 9.9086 4.02426 9.49631 4.06315 9.09959C4.09427 7.98721 4.22651 6.99539 4.45988 6.12027C4.69324 5.24514 5.05107 4.51392 5.54504 3.92272C6.03511 3.33153 6.68076 2.89591 7.47032 2.61975C7.63756 2.01689 7.94483 1.51126 8.38823 1.10676C8.83163 0.702252 9.38004 0.5 10.0374 0.5C10.6947 0.5 11.2509 0.702252 11.6982 1.10676C12.1454 1.51126 12.4488 2.01689 12.6005 2.61975C13.3979 2.89591 14.0357 3.33153 14.5219 3.92272C15.0081 4.51392 15.3659 5.24903 15.6032 6.12027C15.8404 6.9915 15.9727 7.98721 16.0038 9.09959C16.0349 9.49631 16.0816 9.9086 16.1399 10.3325C16.1983 10.7565 16.2838 11.1532 16.4005 11.5227C16.5172 11.8922 16.6806 12.1917 16.8906 12.4251C17.2873 12.8296 17.6724 13.2419 18.038 13.6541C18.4036 14.0664 18.5864 14.5059 18.5864 14.9688C18.5864 15.2722 18.4775 15.5172 18.2597 15.7C18.0419 15.8867 17.7346 15.98 17.3418 15.98H2.74463C2.35179 15.98 2.04841 15.8867 1.82671 15.7ZM8.68383 19.1772C8.2871 18.9633 7.96428 18.6715 7.71924 18.3137C7.47421 17.9559 7.3303 17.5669 7.28362 17.1469H12.7911C12.7444 17.5631 12.6005 17.952 12.3594 18.3137C12.1182 18.6754 11.7954 18.9633 11.3948 19.1772C10.9942 19.3911 10.5391 19.5 10.0335 19.5C9.52784 19.5 9.08055 19.395 8.68383 19.1772Z"
            fill={color}
        />
    </svg>
);

export const IcAlarmDot = ({
    color = 'currentColor',
    size = 20,
    dotColor = '#FF0000',
    ...props
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <path
            d="M1.82671 15.7C1.6089 15.5133 1.5 15.2683 1.5 14.9688C1.5 14.5059 1.6828 14.0664 2.04841 13.6541C2.41402 13.238 2.7913 12.8296 3.17636 12.4251C3.39417 12.1917 3.56141 11.8922 3.6781 11.5227C3.79478 11.1532 3.87646 10.7565 3.92702 10.3325C3.97758 9.9086 4.02426 9.49631 4.06315 9.09959C4.09427 7.98721 4.22651 6.99539 4.45988 6.12027C4.69324 5.24514 5.05107 4.51392 5.54504 3.92272C6.03511 3.33153 6.68076 2.89591 7.47032 2.61975C7.63756 2.01689 7.94483 1.51126 8.38823 1.10676C8.83163 0.702252 9.38004 0.5 10.0374 0.5C10.6947 0.5 11.2509 0.702252 11.6982 1.10676C12.1454 1.51126 12.4488 2.01689 12.6005 2.61975C13.3979 2.89591 14.0357 3.33153 14.5219 3.92272C15.0081 4.51392 15.3659 5.24903 15.6032 6.12027C15.8404 6.9915 15.9727 7.98721 16.0038 9.09959C16.0349 9.49631 16.0816 9.9086 16.1399 10.3325C16.1983 10.7565 16.2838 11.1532 16.4005 11.5227C16.5172 11.8922 16.6806 12.1917 16.8906 12.4251C17.2873 12.8296 17.6724 13.2419 18.038 13.6541C18.4036 14.0664 18.5864 14.5059 18.5864 14.9688C18.5864 15.2722 18.4775 15.5172 18.2597 15.7C18.0419 15.8867 17.7346 15.98 17.3418 15.98H2.74463C2.35179 15.98 2.04841 15.8867 1.82671 15.7ZM8.68383 19.1772C8.2871 18.9633 7.96428 18.6715 7.71924 18.3137C7.47421 17.9559 7.3303 17.5669 7.28362 17.1469H12.7911C12.7444 17.5631 12.6005 17.952 12.3594 18.3137C12.1182 18.6754 11.7954 18.9633 11.3948 19.1772C10.9942 19.3911 10.5391 19.5 10.0335 19.5C9.52784 19.5 9.08055 19.395 8.68383 19.1772Z"
            fill={color}
        />
        <circle cx="16" cy="4" r="3" fill={dotColor} />
    </svg>
);

export const IcChange = ({ color = 'currentColor', size = 24, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ '--icon-color': color }}
        {...props}
    >
        <path
            d="M12 4V1L8 5L12 9V6C15.31 6 18 8.69 18 12C18 13.01 17.75 13.97 17.3 14.8L18.76 16.26C19.54 15.03 20 13.57 20 12C20 7.58 16.42 4 12 4ZM12 18C8.69 18 6 15.31 6 12C6 10.99 6.25 10.03 6.7 9.2L5.24 7.74C4.46 8.97 4 10.43 4 12C4 16.42 7.58 20 12 20V23L16 19L12 15V18Z"
            fill="var(--icon-color)"
        />
    </svg>
);

export const IcEdit = ({ color = 'currentColor', size = 24, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ '--icon-color': color }}
        {...props}
    >
        <path
            d="M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z"
            fill="var(--icon-color)"
        />
    </svg>
);

export const IcRight = ({ color = 'currentColor', size = 24, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ '--icon-color': color }}
        {...props}
    >
        <path
            d="M8.59 16.59L13.17 12L8.59 7.41L10 6L16 12L10 18L8.59 16.59Z"
            fill="var(--icon-color)"
        />
    </svg>
);

export const IcSearch = ({ color = 'currentColor', size = 24, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ '--icon-color': color }}
        {...props}
    >
        <path
            d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3S3 5.91 3 9.5S5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5S14 7.01 14 9.5S11.99 14 9.5 14Z"
            fill="var(--icon-color)"
        />
    </svg>
);

export const Delete = ({ color = 'currentColor', size = 20, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ '--icon-color': color }}
        {...props}
    >
        <path
            d="M10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1ZM6.99512 5.93457C6.7052 5.64466 6.22448 5.64466 5.93457 5.93457C5.64466 6.22448 5.64466 6.70521 5.93457 6.99512L8.95312 10.0137L5.94824 13.0195C5.65845 13.3095 5.65837 13.7902 5.94824 14.0801C6.23812 14.3699 6.71887 14.3699 7.00879 14.0801L10.0137 11.0752L13.0049 14.0654C13.2948 14.3553 13.7755 14.3553 14.0654 14.0654C14.3553 13.7755 14.3553 13.2948 14.0654 13.0049L11.0752 10.0137L14.0801 7.00879C14.3699 6.71887 14.3699 6.23812 14.0801 5.94824C13.7902 5.65836 13.3095 5.65843 13.0195 5.94824L10.0137 8.95312L6.99512 5.93457Z"
            fill="var(--icon-color)"
        />
    </svg>
);

export const Check = ({
    backgroundColor = '#FFCC00',
    checkColor = '#FFFFFF',
    size = 20,
    ...props
}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_39_1793)">
            <path
                d="M20 10L18.57 12.3L18.66 15L16.27 16.27L15 18.66L12.3 18.57L10 20L7.7 18.57L5 18.66L3.73 16.27L1.34 15L1.43 12.3L0 10L1.43 7.7L1.34 5L3.73 3.73L5 1.34L7.7 1.43L10 0L12.3 1.43L15 1.34L16.27 3.73L18.66 5L18.57 7.7L20 10Z"
                fill={backgroundColor}
            />
            <path
                d="M5 9.61357L8.73086 14.2228L15 6.479"
                stroke={checkColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_39_1793">
                <rect width="20" height="20" rx="10" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

// 승인대기 메뉴 아이콘
export const PendingApproval = ({ color = '#9B96A2', size = 16, ...props }) => {
    const clipId = `clip0_pending_approval_${String(React.useId()).replace(/:/g, '')}`;
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath={`url(#${clipId})`}>
                <path
                    d="M14.65 6.35C14.74 6.81 14.79 7.28 14.79 7.76C14.79 11.64 11.65 14.78 7.77 14.78C3.89 14.78 0.75 11.65 0.75 7.77C0.75 3.89 3.89 0.75 7.77 0.75C9.71 0.75 11.46 1.54 12.73 2.81"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.96997 6.93006L7.76997 10.5801L14.79 3.56006"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id={clipId}>
                    <rect width="15.54" height="15.54" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

// 기관관리 메뉴 아이콘
export const OrganizationManagement = ({ color = '#9B96A2', size = 16, ...props }) => {
    const clipId = `clip0_org_mgmt_${String(React.useId()).replace(/:/g, '')}`;
    return (
        <svg
            width={size}
            height={size * (17 / 16)}
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath={`url(#${clipId})`}>
                <path
                    d="M11.56 10.38V7.22998H3.71V10.38H0.75V15.89H14.52V10.38H11.56Z"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.63 7.23V0.75"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.63 0.75L12.67 2.63L7.63 4.74"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.04996 15.89V12.97C9.04996 12.19 8.40996 11.55 7.62996 11.55C6.84996 11.55 6.20996 12.19 6.20996 12.97V15.89"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id={clipId}>
                    <rect width="15.27" height="16.64" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

// 사용자 관리 메뉴 아이콘
export const UserManagement = ({ color = '#9B96A2', size = 16, ...props }) => {
    const clipId = `clip0_user_mgmt_${String(React.useId()).replace(/:/g, '')}`;
    return (
        <svg
            width={size}
            height={size * (17 / 16)}
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath={`url(#${clipId})`}>
                <path
                    d="M7.54997 7.67C9.46087 7.67 11.01 6.12091 11.01 4.21C11.01 2.29909 9.46087 0.75 7.54997 0.75C5.63906 0.75 4.08997 2.29909 4.08997 4.21C4.08997 6.12091 5.63906 7.67 7.54997 7.67Z"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.01 9.92004H9.09C11.99 9.92004 14.35 12.28 14.35 15.18V15.99H0.75V15.18C0.75 12.28 3.11 9.92004 6.01 9.92004Z"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id={clipId}>
                    <rect width="15.1" height="16.74" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

// 디딤 h/w 메뉴 아이콘
export const DidimHw = ({ color = '#9B96A2', size = 16, ...props }) => {
    const clipId = `clip0_didim_hw_${String(React.useId()).replace(/:/g, '')}`;
    return (
        <svg
            width={size}
            height={size * (18 / 16)}
            viewBox="0 0 16 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath={`url(#${clipId})`}>
                <path
                    d="M6.73 16.46H0.75V2.53C0.75 1.55 1.55 0.75 2.53 0.75H12.54C13.52 0.75 14.32 1.55 14.32 2.53V8.61"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.0501 2.91003H4.01005C3.55166 2.91003 3.18005 3.28164 3.18005 3.74003V5.91003C3.18005 6.36843 3.55166 6.74003 4.01005 6.74003H11.0501C11.5084 6.74003 11.8801 6.36843 11.8801 5.91003V3.74003C11.8801 3.28164 11.5084 2.91003 11.0501 2.91003Z"
                    fill={color}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M15.07 13.35V12.74C15.07 12.57 14.94 12.42 14.77 12.39L14.14 12.29C14.06 11.93 13.91 11.59 13.72 11.29L14.09 10.78C14.19 10.64 14.18 10.44 14.05 10.32L13.62 9.89C13.5 9.77 13.3 9.75 13.16 9.85L12.65 10.22C12.34 10.03 12.01 9.89 11.65 9.8L11.55 9.17C11.52 9 11.37 8.87 11.2 8.87H10.59C10.42 8.87 10.27 9 10.24 9.17L10.14 9.8C9.77997 9.88 9.43997 10.03 9.13997 10.22L8.62997 9.85C8.48997 9.75 8.28997 9.76 8.16997 9.89L7.73997 10.32C7.61997 10.44 7.59997 10.64 7.69997 10.78L8.06997 11.29C7.87997 11.6 7.73997 11.93 7.64997 12.29L7.01997 12.39C6.84997 12.42 6.71997 12.57 6.71997 12.74V13.35C6.71997 13.52 6.84997 13.67 7.01997 13.7L7.64997 13.8C7.72997 14.16 7.87997 14.5 8.06997 14.8L7.69997 15.31C7.59997 15.45 7.60997 15.65 7.73997 15.77L8.16997 16.2C8.28997 16.32 8.48997 16.34 8.62997 16.24L9.13997 15.87C9.44997 16.06 9.77997 16.2 10.14 16.29L10.24 16.92C10.27 17.09 10.42 17.22 10.59 17.22H11.2C11.37 17.22 11.52 17.09 11.55 16.92L11.65 16.29C12.01 16.21 12.35 16.06 12.65 15.87L13.16 16.24C13.3 16.34 13.5 16.33 13.62 16.2L14.05 15.77C14.17 15.65 14.19 15.45 14.09 15.31L13.72 14.8C13.91 14.49 14.05 14.16 14.14 13.8L14.77 13.7C14.94 13.67 15.07 13.52 15.07 13.35ZM10.9 14.31C10.2 14.31 9.62997 13.74 9.62997 13.04C9.62997 12.34 10.2 11.77 10.9 11.77C11.6 11.77 12.17 12.34 12.17 13.04C12.17 13.74 11.6 14.31 10.9 14.31Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id={clipId}>
                    <rect width="15.07" height="17.21" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

// 콘텐츠 메뉴 아이콘 (4개 원)
export const Contents = ({ color = '#9B96A2', size = 16, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.96517 7.18035C5.74087 7.18035 7.18035 5.74087 7.18035 3.96517C7.18035 2.18948 5.74087 0.75 3.96517 0.75C2.18948 0.75 0.75 2.18948 0.75 3.96517C0.75 5.74087 2.18948 7.18035 3.96517 7.18035Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M3.96517 15.3273C5.74087 15.3273 7.18035 13.8878 7.18035 12.1121C7.18035 10.3365 5.74087 8.89697 3.96517 8.89697C2.18948 8.89697 0.75 10.3365 0.75 12.1121C0.75 13.8878 2.18948 15.3273 3.96517 15.3273Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.1121 7.18035C13.8878 7.18035 15.3273 5.74087 15.3273 3.96517C15.3273 2.18948 13.8878 0.75 12.1121 0.75C10.3365 0.75 8.89697 2.18948 8.89697 3.96517C8.89697 5.74087 10.3365 7.18035 12.1121 7.18035Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.1121 15.3273C13.8878 15.3273 15.3273 13.8878 15.3273 12.1121C15.3273 10.3365 13.8878 8.89697 12.1121 8.89697C10.3365 8.89697 8.89697 10.3365 8.89697 12.1121C8.89697 13.8878 10.3365 15.3273 12.1121 15.3273Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

/** 챔피언십 아이콘 (사용자 상세 탭 메뉴 등) */
export const Championship = ({ color = '#9B96A2', size = 16, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M18.5 5.29C18.31 4.26 17.34 3.57 16.31 3.71L15.66 3.8V3.39C15.66 2.62 15.04 2 14.27 2H5.40004C4.63004 2 4.01004 2.62 4.01004 3.39V3.8L3.37004 3.71C2.34004 3.57 1.37004 4.26 1.18004 5.29C0.900039 6.81 0.800039 8.92 1.93004 10.27C2.55004 11.02 3.46004 11.41 4.60004 11.47C5.44004 13.43 7.10004 15.07 9.08004 15.41V16.38H8.47004C8.08004 16.38 7.76004 16.7 7.76004 17.09V17.13H6.59004C6.20004 17.13 5.88004 17.45 5.88004 17.84V17.92C5.88004 18.31 6.20004 18.63 6.59004 18.63H13.07C13.46 18.63 13.78 18.31 13.78 17.92V17.84C13.78 17.45 13.46 17.13 13.07 17.13H11.9V17.09C11.9 16.7 11.58 16.38 11.19 16.38H10.58V15.41C12.56 15.07 14.22 13.43 15.06 11.47C16.2 11.41 17.11 11.02 17.73 10.27C18.86 8.91 18.76 6.81 18.48 5.29H18.5ZM3.09004 9.31C2.30004 8.36 2.48004 6.56 2.66004 5.57C2.70004 5.32 2.92004 5.15 3.18004 5.19L4.02004 5.3V8.73C4.02004 9.11 4.06004 9.5 4.13004 9.89C3.69004 9.79 3.34004 9.6 3.09004 9.3V9.31ZM12.36 7.28L11.52 8.17L11.67 9.39C11.72 9.79 11.31 10.09 10.94 9.92L9.83004 9.4L8.72004 9.92C8.35004 10.09 7.94004 9.79 7.99004 9.39L8.14004 8.17L7.30004 7.28C7.02004 6.99 7.18004 6.5 7.58004 6.43L8.78004 6.2L9.37004 5.13C9.56004 4.78 10.07 4.78 10.27 5.13L10.86 6.2L12.06 6.43C12.46 6.51 12.61 6.99 12.34 7.28H12.36ZM16.6 9.31C16.35 9.61 16 9.8 15.56 9.9C15.63 9.51 15.67 9.12 15.67 8.74V5.31L16.51 5.2C16.76 5.17 16.98 5.33 17.03 5.58C17.21 6.57 17.39 8.36 16.6 9.32V9.31Z"
            fill={color}
        />
    </svg>
);

/** 랭킹 아이콘 (사용자 상세 탭 메뉴 등) */
export const RankingIcon = ({ color = '#9B96A2', size = 16, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M14.23 11.02H10.97V8.63C10.97 7.93 10.4 7.36 9.7 7.36H5.8C5.1 7.36 4.53 7.93 4.53 8.63V9.41H1.27C0.57 9.41 0 9.98 0 10.68V14.73C0 15.14 0.34 15.48 0.75 15.48H5.18C5.18 15.48 5.24 15.5 5.28 15.5H14.75C15.16 15.5 15.5 15.16 15.5 14.75V12.29C15.5 11.59 14.93 11.02 14.23 11.02ZM1.5 10.92H4.53V13.99H1.5V10.92ZM6.03 10.17V8.87H9.47V14.01H6.03V10.17ZM14 14H10.97V12.52H14V14ZM9.08 5.6C9.08 6.23 8.69 6.52 8.15 6.52C7.61 6.52 7.22 6.23 7.22 5.6V2.64H6.25C5.8 2.64 5.58 2.41 5.58 2C5.58 1.54 5.73 1.41 6.45 1.29C7 1.19 7.28 0.94 7.51 0.61C7.8 0.21 7.98 0 8.34 0C8.8 0 9.07 0.2 9.07 0.63V5.6H9.08Z"
            fill={color}
        />
    </svg>
);

/** 기본정보 아이콘 (사용자 상세 탭 메뉴 등) */
export const BasicInfoIcon = ({ color = '#9B96A2', size = 16, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10 2.5C14.1464 2.5 17.5 5.85357 17.5 10C17.5 14.1464 14.1464 17.5 10 17.5C5.85357 17.5 2.5 14.1464 2.5 10C2.5 5.85357 5.85357 2.5 10 2.5ZM10 5.30714C8.92857 5.30714 8.05 6.175 8.05 7.25714C8.05 8.33929 8.91786 9.20714 10 9.20714C11.0821 9.20714 11.95 8.33929 11.95 7.25714C11.95 6.175 11.0821 5.30714 10 5.30714ZM13.8143 13.8679H6.175V13.6857C6.175 11.9179 7.62143 10.4607 9.4 10.4607H10.5893C12.3571 10.4607 13.8143 11.9071 13.8143 13.6857V13.8679Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

// 이벤트 관리 메뉴 아이콘 (캘린더 + 체크)
export const EventManagement = ({ color = '#9B96A2', size = 16, ...props }) => {
    const clipId = `clip0_event_mgmt_${String(React.useId()).replace(/:/g, '')}`;
    return (
        <svg
            width={size}
            height={size * (15 / 16)}
            viewBox="0 0 16 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath={`url(#${clipId})`}>
                <path
                    d="M10.0822 10.9529L11.4285 12.4181L15.0293 9.09839"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.445 12.1003V12.7561C14.445 13.5962 13.7562 14.2725 12.9003 14.2725H3.11036C2.25452 14.2725 1.56567 13.5962 1.56567 12.7561V7.39746"
                    stroke={color}
                    strokeWidth="1.42"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.08747 4.03687H13.9126C14.6641 4.03687 15.2695 4.63113 15.2695 5.36883V7.29506H0.741089V5.36883C0.741089 4.63113 1.34644 4.03687 2.09791 4.03687H2.08747Z"
                    stroke={color}
                    strokeWidth="1.42"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.00525 14.2725V11.834V9.15979V4.03684L11.7 0.727417"
                    stroke={color}
                    strokeWidth="1.42"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.00526 4.03684L4.43579 0.727417"
                    stroke={color}
                    strokeWidth="1.42"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id={clipId}>
                    <rect width="16" height="15" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

// 공지 및 푸시알림 메뉴 아이콘 (벨 + 알림)
export const NoticeAndPush = ({ color = '#9B96A2', size = 16, ...props }) => {
    const clipId = `clip0_notice_push_${String(React.useId()).replace(/:/g, '')}`;
    return (
        <svg
            width={size}
            height={size * (17 / 16)}
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath={`url(#${clipId})`}>
                <path
                    d="M13.0223 7.47554C13.0422 7.71898 13.0521 7.96241 13.062 8.22614C13.0918 8.571 13.1315 8.92602 13.1811 9.30131C13.2307 9.66647 13.3002 10.0113 13.3995 10.3359C13.4987 10.6605 13.6377 10.9141 13.8163 11.1169C14.1538 11.472 14.4814 11.827 14.789 12.182C15.0967 12.537 15.2556 12.9224 15.2556 13.3282C15.2556 13.5919 15.1662 13.8049 14.9776 13.9672C14.789 14.1295 14.531 14.2106 14.1935 14.2106H1.80642C1.46895 14.2106 1.21089 14.1295 1.0223 13.9672C0.833715 13.8049 0.744385 13.5919 0.744385 13.3282C0.744385 12.9224 0.903194 12.5471 1.21089 12.182C1.51858 11.8168 1.84612 11.4618 2.17367 11.1169C2.36225 10.9141 2.50121 10.6504 2.60046 10.3359C2.69972 10.0113 2.7692 9.66647 2.8089 9.30131C2.8486 8.93616 2.88831 8.571 2.92801 8.22614C2.95778 7.26253 3.06697 6.40036 3.26548 5.63962C3.46399 4.87888 3.77168 4.25 4.18855 3.7327C4.60543 3.2154 5.15133 2.8401 5.82627 2.59666C5.96523 2.06921 6.23322 1.63306 6.61039 1.28819C6.98756 0.933177 7.45406 0.760742 8.00989 0.760742C8.56572 0.760742 9.04215 0.933177 9.41932 1.28819C9.79649 1.6432 10.0546 2.07936 10.1836 2.59666C10.5111 2.70824 10.799 2.86038 11.067 3.03282C11.2059 3.12411 11.335 3.22554 11.4541 3.33711M10.3325 14.2005C10.2928 14.5656 10.1737 14.9004 9.96523 15.2148C9.75679 15.5292 9.4888 15.7828 9.14141 15.9654C8.80394 16.148 8.41684 16.2494 7.98012 16.2494C7.54339 16.2494 7.16622 16.1581 6.82875 15.9654C6.49128 15.7828 6.21337 15.5292 6.00493 15.2148C5.79649 14.9004 5.67739 14.5656 5.63768 14.2005"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M12.9529 7.47549C14.2246 7.47549 15.2556 6.42191 15.2556 5.12227C15.2556 3.82262 14.2246 2.76904 12.9529 2.76904C11.6811 2.76904 10.6501 3.82262 10.6501 5.12227C10.6501 6.42191 11.6811 7.47549 12.9529 7.47549Z"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id={clipId}>
                    <rect width="16" height="17" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

// 일반관리 메뉴 아이콘 (목록 + 불릿)
export const GeneralManagement = ({ color = '#9B96A2', size = 16, ...props }) => {
    const clipId = `clip0_general_mgmt_${String(React.useId()).replace(/:/g, '')}`;
    return (
        <svg
            width={size}
            height={size * (13 / 16)}
            viewBox="0 0 16 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath={`url(#${clipId})`}>
                <path
                    d="M1.38401 2.71734C2.14838 2.71734 2.76802 2.10904 2.76802 1.35867C2.76802 0.608297 2.14838 0 1.38401 0C0.619643 0 0 0.608297 0 1.35867C0 2.10904 0.619643 2.71734 1.38401 2.71734Z"
                    fill={color}
                />
                <path
                    d="M4.57153 1.35864H15.2137"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M1.38401 7.86382C2.14838 7.86382 2.76802 7.25553 2.76802 6.50515C2.76802 5.75478 2.14838 5.14648 1.38401 5.14648C0.619643 5.14648 0 5.75478 0 6.50515C0 7.25553 0.619643 7.86382 1.38401 7.86382Z"
                    fill={color}
                />
                <path
                    d="M4.57153 6.50513H15.2137"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M1.38401 13.0001C2.14838 13.0001 2.76802 12.3918 2.76802 11.6414C2.76802 10.891 2.14838 10.2827 1.38401 10.2827C0.619643 10.2827 0 10.891 0 11.6414C0 12.3918 0.619643 13.0001 1.38401 13.0001Z"
                    fill={color}
                />
                <path
                    d="M4.57153 11.6414H15.2137"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id={clipId}>
                    <rect width="16" height="13" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

/** 대시보드 아이콘 (사용자 상세 탭 메뉴 등) */
export const Dashboard = ({ color = '#9B96A2', size = 16, ...props }) => {
    const clipId = `clip0_dashboard_${String(React.useId()).replace(/:/g, '')}`;
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath={`url(#${clipId})`}>
                <path
                    d="M13.8971 0.699707H2.10281C1.32015 0.699707 0.685669 1.34713 0.685669 2.14577V5.40175C0.685669 6.20039 1.32015 6.84781 2.10281 6.84781H13.8971C14.6798 6.84781 15.3142 6.20039 15.3142 5.40175V2.14577C15.3142 1.34713 14.6798 0.699707 13.8971 0.699707Z"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M8.47538 9.15222H2.10281C1.32015 9.15222 0.685669 9.79965 0.685669 10.5983V13.8543C0.685669 14.6529 1.32015 15.3003 2.10281 15.3003H8.47538C9.25805 15.3003 9.89253 14.6529 9.89253 13.8543V10.5983C9.89253 9.79965 9.25805 9.15222 8.47538 9.15222Z"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.8971 9.15222H13.3669C12.5842 9.15222 11.9497 9.79965 11.9497 10.5983V13.8543C11.9497 14.6529 12.5842 15.3003 13.3669 15.3003H13.8971C14.6798 15.3003 15.3143 14.6529 15.3143 13.8543V10.5983C15.3143 9.79965 14.6798 9.15222 13.8971 9.15222Z"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id={clipId}>
                    <rect width="16" height="16" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

/** 디딤수(걸음수) 아이콘 (사용자 상세 탭 메뉴 등) */
export const StepCount = ({ color = '#9B96A2', size = 16, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M5.86108 8.47138C6.10108 10.3814 6.44108 11.7214 4.46108 11.9714C2.74108 12.1914 2.02108 10.7914 1.79108 8.98138C1.44108 6.24138 -1.07892 1.65138 3.28108 0.821376C7.64108 -0.00862357 5.62108 6.56138 5.86108 8.47138ZM10.3711 12.0714C10.1311 13.9814 9.79108 15.3214 11.7711 15.5714C13.4911 15.7914 14.2111 14.3914 14.4411 12.5814C14.7911 9.84138 17.3111 5.25138 12.9511 4.42138C8.59108 3.59138 10.6111 10.1614 10.3711 12.0714Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

/** 심박수 아이콘 (사용자 상세 탭 메뉴 등) */
export const HeartRate = ({ color = '#9B96A2', size = 16, ...props }) => (
    <svg
        width={size}
        height={size * (15 / 16)}
        viewBox="0 0 16 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M7.75 13.26L2.24 7.75L1.89 7.4C0.37 5.88 0.37 3.41 1.89 1.89C3.41 0.37 5.88 0.37 7.4 1.89L7.75 2.24L8.1 1.89C9.62 0.37 12.09 0.37 13.61 1.89C15.13 3.41 15.13 5.88 13.61 7.4L13.26 7.75L7.75 13.26Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

/** 디딤활동 아이콘 (사용자 상세 탭 메뉴 등) */
export const DidimActivity = ({ color = '#9B96A2', size = 16, ...props }) => {
    const clipId = `clip0_didim_activity_${String(React.useId()).replace(/:/g, '')}`;
    return (
        <svg
            width={size * (11 / 16)}
            height={size}
            viewBox="0 0 11 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath={`url(#${clipId})`}>
                <path
                    d="M7.42001 4.32C8.61294 4.32 9.58001 3.35294 9.58001 2.16C9.58001 0.967065 8.61294 0 7.42001 0C6.22707 0 5.26001 0.967065 5.26001 2.16C5.26001 3.35294 6.22707 4.32 7.42001 4.32Z"
                    fill={color}
                />
                <path
                    d="M7.59995 15.2L7.38995 11.9L5.44995 9.32C5.57995 6.4 6.50995 4.5 6.50995 4.5L7.18995 7.04L9.80995 7.29"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.50011 4.5L3.60011 5.27L2.86011 7.33"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.44 9.31995L3.71 11.8599L0.75 11.3499"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.58002 15.2H5.27002"
                    stroke={color}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id={clipId}>
                    <rect width="10.54" height="15.95" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

/** 챌린지 아이콘 (사용자 상세 탭 메뉴 등) */
export const Challenge = ({ color = '#9B96A2', size = 16, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M12.08 17.07H7.41V11.12H12.08V17.07ZM12.08 17.07V8.3H16.75V17.07H12.08ZM2.75 8.61L8.68 7.17L15.88 3.08M15.88 3.08L14.91 5.78M15.88 3.08L12.95 2.75M7.42 17.07H2.75V13.88H7.42V17.07Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

/** 포인트 아이콘 (사용자 상세 탭 메뉴 등) */
export const PointIcon = ({ color = '#9B96A2', size = 16, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10 2C5.58788 2 2 5.58788 2 10C2 14.4121 5.58788 18 10 18C14.4121 18 18 14.4121 18 10C18 5.58788 14.4121 2 10 2ZM10 16.5455C6.39273 16.5455 3.45455 13.6073 3.45455 10C3.45455 6.39273 6.39273 3.45455 10 3.45455C13.6073 3.45455 16.5455 6.39273 16.5455 10C16.5455 13.6073 13.6073 16.5455 10 16.5455ZM10.4945 5.72364C9.00121 5.72364 8.34182 5.73333 7.35273 5.8303V14.1115H9.17576V11.0376C9.66061 11.0958 10.1939 11.1345 10.737 11.1345C12.7927 11.1345 13.52 10.5624 13.52 8.41939C13.52 6.27636 12.783 5.71394 10.4945 5.71394V5.72364ZM10.4558 9.73818H9.17576V7.1297H10.4558C11.3964 7.1297 11.6776 7.39152 11.6776 8.42909C11.6776 9.46667 11.3867 9.72849 10.4558 9.73818Z"
            fill={color}
        />
    </svg>
);

export const Phone = ({ color = 'currentColor', size = 24, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ '--icon-color': color }}
        {...props}
    >
        <path
            d="M6.62 10.79C8.06 13.62 10.38 15.94 13.21 17.38L15.41 15.18C15.69 14.9 16.08 14.82 16.43 14.93C17.55 15.3 18.76 15.5 20 15.5C20.55 15.5 21 15.95 21 16.5V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 3C3 2.45 3.45 2 4 2H7.5C8.05 2 8.5 2.45 8.5 3C8.5 4.24 8.7 5.45 9.07 6.57C9.18 6.92 9.1 7.31 8.82 7.59L6.62 10.79Z"
            fill="var(--icon-color)"
        />
    </svg>
);

export const Message = ({ color = 'currentColor', size = 24, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ '--icon-color': color }}
        {...props}
    >
        <path
            d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z"
            fill="var(--icon-color)"
        />
    </svg>
);

export const Visible = ({ color = 'currentColor', size = 20, ...props }) => (
    <svg
        width={size}
        height={size * 0.55}
        viewBox="0 0 20 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ '--icon-color': color }}
        {...props}
    >
        <path
            d="M9.98875 1C5.23 1 1 5.5 1 5.5C1 5.5 5.24125 10 10 10C14.7588 10 19 5.5 19 5.5C19 5.5 14.7587 1 9.98875 1Z"
            stroke="var(--icon-color)"
            strokeWidth="1.5"
            strokeLinejoin="round"
        />
        <path
            d="M10.0001 8.55521C11.8275 8.55521 13.3089 7.13306 13.3089 5.37874C13.3089 3.62442 11.8275 2.20227 10.0001 2.20227C8.17269 2.20227 6.69128 3.62442 6.69128 5.37874C6.69128 7.13306 8.17269 8.55521 10.0001 8.55521Z"
            fill="var(--icon-color)"
        />
    </svg>
);

export const Invisible = ({ color = 'currentColor', size = 19, ...props }) => (
    <svg
        width={size}
        height={size * 0.74}
        viewBox="0 0 19 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ '--icon-color': color }}
        {...props}
    >
        <path
            d="M14.4083 10.1268C16.4818 8.73042 17.8754 7.0991 17.8754 7.0991C17.8754 7.0991 13.6725 2.12683 8.9456 2.12683C8.58886 2.12683 8.23211 2.15293 7.87537 2.20513"
            stroke="var(--icon-color)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M4.11772 4.12683C2.17449 5.51526 0.875366 7.08882 0.875366 7.08882C0.875366 7.08882 4.99109 12.1268 9.60899 12.1268C10.0348 12.1268 10.4605 12.0872 10.8754 12.0078"
            stroke="var(--icon-color)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M10.155 4.69031C11.0599 4.94997 11.7465 5.64964 11.9744 6.51062L10.155 4.69031Z"
            fill="var(--icon-color)"
            stroke="var(--icon-color)"
            strokeWidth="1.25"
        />
        <path
            d="M8.59351 9.57251C7.68974 9.31256 7.00309 8.61522 6.77515 7.75513L8.59351 9.57251Z"
            fill="var(--icon-color)"
            stroke="var(--icon-color)"
            strokeWidth="1.25"
        />
        <path
            d="M4 1L15 13"
            stroke="var(--icon-color)"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

// Social Icons - individual exports
export { Kakao, Apple, Google } from './socialIcons';

// Activity Icons based on Figma design

export const Calendar = ({ size = 20, color = '#9B96A2', ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M17.1721 1.93081H15.6558V1.4291C15.6558 0.918093 15.2372 0.5 14.7256 0.5C14.214 0.5 13.7953 0.918093 13.7953 1.4291V1.93081H6.21395V1.4291C6.21395 0.918093 5.79535 0.5 5.28372 0.5C4.77209 0.5 4.35349 0.918093 4.35349 1.4291V1.93081H2.83721C1.27442 1.93081 0 3.20367 0 4.76455V16.6756C0 18.2364 1.27442 19.5 2.82791 19.5H17.1628C18.7256 19.5 19.9907 18.2271 19.9907 16.6756V4.76455C19.9907 3.20367 18.7163 1.9401 17.1628 1.9401L17.1721 1.93081ZM17.1721 18.1064H2.82791C2.03721 18.1064 1.39535 17.4653 1.39535 16.6756V8.24866H18.6047V16.6756C18.6047 17.4653 17.9628 18.1064 17.1721 18.1064ZM5.6 10.2648V11.5655C5.6 11.9279 5.30233 12.2252 4.93954 12.2252H3.63721C3.27442 12.2252 2.97674 11.9279 2.97674 11.5655V10.2648C2.97674 9.90244 3.27442 9.60513 3.63721 9.60513H4.93954C5.30233 9.60513 5.6 9.90244 5.6 10.2648ZM9.54419 10.2648V11.5655C9.54419 11.9279 9.24651 12.2252 8.88372 12.2252H7.5814C7.2186 12.2252 6.92093 11.9279 6.92093 11.5655V10.2648C6.92093 9.90244 7.2186 9.60513 7.5814 9.60513H8.88372C9.24651 9.60513 9.54419 9.90244 9.54419 10.2648ZM13.4884 10.2648V11.5655C13.4884 11.9279 13.1907 12.2252 12.8279 12.2252H11.5256C11.1628 12.2252 10.8651 11.9279 10.8651 11.5655V10.2648C10.8651 9.90244 11.1628 9.60513 11.5256 9.60513H12.8279C13.1907 9.60513 13.4884 9.90244 13.4884 10.2648Z"
            fill={color}
        />
    </svg>
);

export const Link = ({ color = '#9B96A2', size = 20, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <path
            d="M14 2C15.6569 2 17 3.34315 17 5C17 6.65685 15.6569 8 14 8C13.2091 8 12.492 7.69151 11.9561 7.19141L7.9707 9.58301C7.98966 9.71931 8 9.85847 8 10C8 10.1412 7.98957 10.28 7.9707 10.416L11.9561 12.8076C12.492 12.3078 13.2094 12 14 12C15.6569 12 17 13.3431 17 15C17 16.6569 15.6569 18 14 18C12.3431 18 11 16.6569 11 15C11 14.8585 11.0094 14.7193 11.0283 14.583L7.04297 12.1914C6.50707 12.6912 5.79062 13 5 13C3.34315 13 2 11.6569 2 10C2 8.34315 3.34315 7 5 7C5.79038 7 6.50712 7.30807 7.04297 7.80762L11.0283 5.41602C11.0095 5.28006 11 5.14115 11 5C11 3.34315 12.3431 2 14 2ZM14 14C13.4477 14 13 14.4477 13 15C13 15.5523 13.4477 16 14 16C14.5523 16 15 15.5523 15 15C15 14.4477 14.5523 14 14 14ZM5 9C4.44772 9 4 9.44772 4 10C4 10.5523 4.44772 11 5 11C5.55228 11 6 10.5523 6 10C6 9.44772 5.55228 9 5 9ZM14 4C13.4477 4 13 4.44772 13 5C13 5.55228 13.4477 6 14 6C14.5523 6 15 5.55228 15 5C15 4.44772 14.5523 4 14 4Z"
            fill={color}
        />
    </svg>
);

export const Union = ({ color = '#9B96A2', size = 20, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <path
            d="M12 3C12.5177 3 12.9438 3.39333 12.9951 3.89746L13 4V16H14.5V8L14.5049 7.89746C14.5562 7.39333 14.9823 7 15.5 7C16.0177 7 16.4438 7.39333 16.4951 7.89746L16.5 8V16H17C17.5523 16 18 16.4477 18 17C18 17.5523 17.5523 18 17 18H3C2.44772 18 2 17.5523 2 17C2 16.4477 2.44772 16 3 16H4V10C4 9.44772 4.44772 9 5 9C5.55228 9 6 9.44772 6 10V16H7.5V12C7.5 11.4477 7.94772 11 8.5 11C9.05228 11 9.5 11.4477 9.5 12V16H11V4L11.0049 3.89746C11.0562 3.39333 11.4823 3 12 3Z"
            fill={color}
        />
    </svg>
);


// Button Checkbox Icons
export const BtCheck = ({ size = 20, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect width="20" height="20" rx="8" fill="#E73829" />
        <path
            d="M5 9.66667L9.34783 13.6667L15 7"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const BtUncheck = ({ size = 20, theme, ...props }) => {
    const isDark = theme?.palette?.mode === 'dark';

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect
                width="20"
                height="20"
                rx="8"
                fill={isDark ? 'white' : 'black'}
                fillOpacity={isDark ? '0.1' : '0.05'}
            />
            <rect
                x="0.625"
                y="0.625"
                width="18.75"
                height="18.75"
                rx="7.375"
                stroke={isDark ? 'white' : 'black'}
                strokeOpacity={isDark ? '0.3' : '0.2'}
                strokeWidth="1.25"
            />
            <path
                d="M5 9.66667L9.34783 13.6667L15 7"
                stroke={isDark ? 'white' : 'black'}
                strokeOpacity={isDark ? '0.3' : '0.2'}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

// Back Icon
export const Back = ({
    color,
    size = 20,
    ...props
}) => {
    const theme = useTheme();
    const finalColor = color || theme?.palette?.figma?.icon;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M11 2L3 10L11 18"
                stroke={finalColor}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.5 10H17.5"
                stroke={finalColor}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

// Home Icon
export const Home = ({
    color,
    size = 20,
    ...props
}) => {
    const theme = useTheme();
    const finalColor = color || theme?.palette?.figma?.icon;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M18.57 9.25994L11.86 2.75994C10.82 1.74994 9.17001 1.74994 8.13001 2.75994L1.43001 9.25994C0.52001 10.1499 1.14001 11.6899 2.42001 11.6899H3.27001V16.7099C3.27001 17.9599 4.29001 18.9799 5.54001 18.9799H7.35001C7.79001 18.9799 8.15001 18.6199 8.15001 18.1799V14.4899C8.15001 13.8799 8.65001 13.3799 9.26001 13.3799H10.75C11.36 13.3799 11.86 13.8799 11.86 14.4899V18.1799C11.86 18.6199 12.22 18.9799 12.66 18.9799H14.47C15.72 18.9799 16.74 17.9599 16.74 16.7099V11.6899H17.59C18.86 11.6899 19.49 10.1399 18.58 9.25994H18.57Z"
                fill={finalColor}
            />
        </svg>
    );
};

// Exercise Icon
export const Exercise = ({
    color,
    size = 20,
    ...props
}) => {
    const theme = useTheme();
    const finalColor = color || theme?.palette?.figma?.icon;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M17 17H3V3M17 4.65L12.8 9.12L9.59 8.32L6.68 13.01M17 4.65V7.02M17 4.65H14.56"
                stroke={finalColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

// Reward Icon
export const Reward = ({
    color,
    size = 18,
    ...props
}) => {
    const theme = useTheme();
    const finalColor = color || theme?.palette?.figma?.icon;

    return (
        <svg
            width={size}
            height={size * 0.94}
            viewBox="0 0 18 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M1.99939 8.38831H15.7826V14.23C15.7826 15.1459 15.0454 15.883 14.1295 15.883H3.65248C2.73658 15.883 1.99939 15.1459 1.99939 14.23V8.38831Z"
                stroke={finalColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.56898 4.72473H15.224C16.0282 4.72473 16.6761 5.37256 16.6761 6.17677V8.27664H1.11694V6.17677C1.11694 5.37256 1.76478 4.72473 2.56898 4.72473Z"
                stroke={finalColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.89099 15.883V4.7247L12.845 1.11694"
                stroke={finalColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.8909 4.7247L5.07092 1.11694"
                stroke={finalColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

// Trophy Icon
export const Trophy = ({
    color,
    size = 20,
    ...props
}) => {
    const theme = useTheme();
    const finalColor = color || theme?.palette?.figma?.icon;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M15.08 11.47C16.22 11.41 17.13 11.02 17.75 10.27C18.88 8.92 18.78 6.83 18.51 5.3C18.32 4.27 17.35 3.57 16.32 3.7L15.67 3.79V2H4.01999V3.79L3.37999 3.7C2.32999 3.57 1.36999 4.27 1.17999 5.3C0.899987 6.82 0.809987 8.92 1.93999 10.27C2.55999 11.02 3.46999 11.41 4.60999 11.47C5.44999 13.43 7.11999 15.07 9.08999 15.41V16.38H8.47999C8.08999 16.38 7.76999 16.7 7.76999 17.09V17.13H6.59999C6.20999 17.13 5.88999 17.45 5.88999 17.84V17.92C5.88999 18.31 6.20999 18.63 6.59999 18.63H13.08C13.47 18.63 13.79 18.31 13.79 17.92V17.84C13.79 17.45 13.47 17.13 13.08 17.13H11.91V17.09C11.91 16.7 11.59 16.38 11.2 16.38H10.59V15.41C12.57 15.07 14.23 13.43 15.07 11.47H15.08ZM16.51 5.19C16.76 5.16 16.98 5.32 17.03 5.57C17.21 6.56 17.39 8.35 16.6 9.31C16.35 9.61 16 9.8 15.56 9.9C15.63 9.51 15.67 9.12 15.67 8.74V5.31L16.51 5.2V5.19ZM3.08999 9.31C2.29999 8.36 2.47999 6.56 2.65999 5.57C2.69999 5.32 2.91999 5.15 3.17999 5.19L4.01999 5.3V8.73C4.01999 9.11 4.05999 9.5 4.12999 9.89C3.68999 9.79 3.33999 9.6 3.08999 9.3V9.31Z"
                fill={finalColor}
            />
        </svg>
    );
};

// Event Icon
export const Event = ({
    color,
    size = 20,
    ...props
}) => {
    const theme = useTheme();
    const finalColor = color || theme?.palette?.figma?.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M7.00014 5.02L2.78014 16.67C2.64014 17.06 3.02014 17.44 3.41014 17.3L15.0601 13.09M11.2801 4.11C12.3701 2.58 11.5701 1.75 11.5701 1.75M16.4101 3.27C15.8001 3.27 15.2601 3.44 15.0901 4.53C14.9201 5.62 13.7701 5.79 13.7701 5.79M18.2201 7.52C16.5001 7.24 15.6601 8.43 15.6601 8.43M5.16014 10.09C5.16014 10.09 5.72014 13.07 9.45014 15.11M15.0601 13.08C14.4601 13.68 12.1701 12.36 9.94014 10.13C7.71014 7.9 6.39014 5.61 6.99014 5.01C7.59014 4.41 9.88014 5.73 12.1101 7.96C14.3401 10.19 15.6601 12.48 15.0601 13.08Z" stroke={finalColor} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

// Setting Icon
export const Setting = ({
    color,
    size = 20,
    ...props
}) => {
    const theme = useTheme();
    const finalColor = color || theme?.palette?.figma?.icon;

    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 10.66V9.34C19 8.96 18.73 8.64 18.35 8.58L17 8.37C16.82 7.59 16.51 6.86 16.1 6.2L16.91 5.09C17.13 4.79 17.1 4.36 16.83 4.1L15.9 3.17C15.63 2.9 15.21 2.87 14.91 3.09L13.8 3.9C13.14 3.49 12.41 3.18 11.63 3L11.42 1.65C11.36 1.28 11.04 1 10.66 1H9.34C8.96 1 8.64 1.27 8.58 1.65L8.37 3C7.59 3.18 6.86 3.49 6.2 3.9L5.09 3.09C4.79 2.87 4.36 2.9 4.1 3.17L3.17 4.1C2.9 4.37 2.87 4.79 3.09 5.09L3.9 6.2C3.49 6.86 3.18 7.59 3 8.37L1.65 8.58C1.28 8.64 1 8.96 1 9.34V10.66C1 11.04 1.27 11.36 1.65 11.42L3 11.63C3.18 12.41 3.49 13.14 3.9 13.8L3.09 14.91C2.87 15.21 2.9 15.64 3.17 15.9L4.1 16.83C4.37 17.1 4.79 17.13 5.09 16.91L6.2 16.1C6.86 16.51 7.59 16.82 8.37 17L8.58 18.35C8.64 18.72 8.96 19 9.34 19H10.66C11.04 19 11.36 18.73 11.42 18.35L11.63 17C12.41 16.82 13.14 16.51 13.8 16.1L14.91 16.91C15.21 17.13 15.64 17.1 15.9 16.83L16.83 15.9C17.1 15.63 17.13 15.21 16.91 14.91L16.1 13.8C16.51 13.14 16.82 12.41 17 11.63L18.35 11.42C18.72 11.36 19 11.04 19 10.66ZM10 12.73C8.49 12.73 7.26 11.51 7.26 9.99C7.26 8.47 8.48 7.25 10 7.25C11.52 7.25 12.74 8.47 12.74 9.99C12.74 11.51 11.52 12.73 10 12.73Z"
                fill={finalColor}
            />
        </svg>
    );
};

// Point Icon
export const Point = ({ size = 20, color = '#FFCC00', ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 20 20"
            fill="none"
            {...props}
        >
            <g clipPath="url(#clip0_135_4207)">
                <circle cx="10" cy="10" r="10" fill={color} />
                <path
                    d="M10.668 5C13.342 5 14.196 5.686 14.196 8.15C14.196 10.642 13.342 11.314 10.948 11.314C10.318 11.314 9.688 11.272 9.128 11.202V14.786H7V5.126C8.162 5.014 8.932 5 10.668 5ZM9.128 9.676H10.626C11.718 9.662 12.054 9.354 12.054 8.15C12.054 6.946 11.718 6.638 10.626 6.638H9.128V9.676Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_135_4207">
                    <rect width="20" height="20" rx="10" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

// Up Icon
export const Up = ({
    direction = 'up',
    color,
    size = 14,
    ...props
}) => {
    const theme = useTheme();
    const finalColor = color || (direction === 'up' ? theme.palette.figma.Red_didim : theme.palette.figma.Blue_didim);
    const upPath =
        'M6.10662 3.02632C6.50368 2.32456 7.49632 2.32456 7.89338 3.02632L12.3603 10.9211C12.7573 11.6228 12.261 12.5 11.4669 12.5H2.53312C1.73901 12.5 1.24269 11.6228 1.63974 10.9211L6.10662 3.02632Z';
    const downPath =
        'M7.89338 10.9737C7.49632 11.6754 6.50368 11.6754 6.10662 10.9737L1.63974 3.0789C1.24269 2.3772 1.73901 1.5 2.53312 1.5H11.4669C12.261 1.5 12.7573 2.3772 12.3603 3.0789L7.89338 10.9737Z';

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 14 14"
            fill="none"
            {...props}
        >
            <path d={direction === 'up' ? upPath : downPath} fill={finalColor} />
        </svg>
    );
};

// Next Icon
export const Next = ({ color = '#9B96A2', size = 20, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M7 4L13 10L7 16"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

// Delete-1 Icon
export const Delete1 = ({ color = '#9B96A2', size = 20, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10.7999 9.75994L15.2799 5.27994C15.5699 4.98994 15.5699 4.50994 15.2799 4.21994C14.9899 3.92994 14.5099 3.92994 14.2199 4.21994L9.73994 8.69994L5.27994 4.23994C4.98994 3.93994 4.50994 3.93994 4.21994 4.23994C3.92994 4.53994 3.92994 4.99994 4.21994 5.29994L8.67994 9.75994L4.23994 14.1999C3.94994 14.4899 3.94994 14.9699 4.23994 15.2599C4.38994 15.4099 4.57994 15.4799 4.76994 15.4799C4.95994 15.4799 5.14994 15.4099 5.29994 15.2599L9.73994 10.8199L14.1999 15.2799C14.3499 15.4299 14.5399 15.4999 14.7299 15.4999C14.9199 15.4999 15.1099 15.4299 15.2599 15.2799C15.5499 14.9899 15.5499 14.5099 15.2599 14.2199L10.7999 9.75994Z"
            fill={color}
        />
    </svg>
);

// Prev Icon
export const Prev = ({ color = '#9B96A2', size = 20, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M13 4L7 10L13 16"
            stroke={color}
            strokeWidth="2"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

// Day Icon
export const Day = ({ color = '#9B96A2', size = 20, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_471_4780)">
            <path
                d="M17.16 1.93H15.64V1.43C15.64 0.92 15.22 0.5 14.71 0.5C14.2 0.5 13.78 0.92 13.78 1.43V1.93H6.2V1.43C6.2 0.92 5.78 0.5 5.27 0.5C4.76 0.5 4.34 0.92 4.34 1.43V1.93H2.82C1.27 1.92 0 3.19 0 4.75V16.66C0 18.22 1.27 19.48 2.83 19.48H17.16C18.72 19.48 19.99 18.21 19.99 16.66V4.75C19.99 3.19 18.72 1.93 17.16 1.93ZM18.6 16.67C18.6 17.46 17.96 18.1 17.17 18.1H2.83C2.04 18.1 1.4 17.46 1.4 16.67V5.39H18.61V16.67H18.6ZM7.74 13.42C7.74 12.84 7.49 12.42 6.66 12.34C6.32 12.3 5.66 12.24 5.66 11.69C5.66 11.07 6.02 10.93 6.7 10.9C7.3 10.86 7.61 10.52 7.61 9.96C7.61 9.24 7.05 8.9 6.41 8.9C4.96 8.9 5.29 10.27 4.35 10.27C3.94 10.27 3.55 10.09 3.55 9.55C3.55 8.09 5.29 7.46 6.45 7.46C8.53 7.46 9.29 8.62 9.29 9.79C9.29 10.56 8.94 11.11 8.27 11.47C9.17 11.72 9.55 12.44 9.55 13.34C9.55 15.24 8.09 16.15 6.31 16.15C4.06 16.15 3.35 14.75 3.35 14.08C3.35 13.59 3.71 13.24 4.2 13.24C5.27 13.24 4.69 14.72 6.35 14.72C7.25 14.72 7.73 14.17 7.73 13.42H7.74ZM13.38 16.15C15.91 16.15 16.58 13.82 16.58 11.7C16.58 8.87 15.32 7.47 13.38 7.47C11.44 7.47 10.18 8.87 10.18 11.7C10.18 13.82 10.85 16.15 13.38 16.15ZM13.38 8.91C14.44 8.91 14.83 10.01 14.83 11.81C14.83 13.96 14.3 14.71 13.38 14.71C12.46 14.71 11.93 13.95 11.93 11.81C11.93 10.01 12.33 8.91 13.38 8.91Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_471_4780">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

// Refresh Icon
export const Refresh = ({ color = '#9B96A2', size = 20, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <path
            d="M15.3603 5.57004C16.3603 6.77004 16.9503 8.32004 16.9503 10C16.9503 13.84 13.8303 16.96 9.99027 16.96C6.15027 16.96 3.03027 13.84 3.03027 10C3.03027 6.16004 6.15027 3.04004 9.99027 3.04004M18.5803 6.58004L15.3703 5.56004L14.3503 8.77004"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

// Info Icon
export const Info = ({ color = '#9B96A2', size = 20, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <path
            d="M19 10C19 14.97 14.97 19 10 19C5.03 19 1 14.97 1 10C1 5.03 5.03 1 10 1C14.97 1 19 5.03 19 10ZM11 13.87V8.92C11 8.37 10.55 7.92 10 7.92C9.45 7.92 9 8.37 9 8.92V13.87C9 14.42 9.45 14.87 10 14.87C10.55 14.87 11 14.42 11 13.87ZM11 6.13C11 5.58 10.55 5.13 10 5.13C9.45 5.13 9 5.58 9 6.13C9 6.68 9.45 7.13 10 7.13C10.55 7.13 11 6.68 11 6.13Z"
            fill={color}
        />
    </svg>
);

// Search Icon
export const Search = ({ color = '#9B96A2', size = 20, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <path
            d="M15.17 15.17L18.37 18.37M17.12 10.06C17.12 13.96 13.96 17.12 10.06 17.12C6.16 17.12 3 13.96 3 10.06C3 6.16 6.16 3 10.06 3C13.96 3 17.12 6.16 17.12 10.06Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

// Photo Empty Icon
export const PhotoEmpty = ({ color = 'white', size = 60, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 61 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g clipPath="url(#clip0_359_6698)">
            <rect x="0.5" width="60" height="60" rx="30" fill={color} fillOpacity="0.1" />
            <circle cx="30.5" cy="26.625" r="12" fill={color} fillOpacity="0.3" />
            <path d="M13.25 55.875C13.25 54.4821 13.25 53.7856 13.2962 53.1981C13.8751 45.8425 19.7175 40.0001 27.0731 39.4212C27.6606 39.375 28.3571 39.375 29.75 39.375C31.1429 39.375 31.8394 39.375 32.4269 39.4212C39.7825 40.0001 45.6249 45.8425 46.2038 53.1981C46.25 53.7856 46.25 54.4821 46.25 55.875V64.125H13.25V55.875Z" fill={color} fillOpacity="0.3" />
        </g>
        <defs>
            <clipPath id="clip0_359_6698">
                <rect x="0.5" width="60" height="60" rx="30" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

// Memo Icon
export const Memo = ({ color = '#9B96A2', size = 20, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M17.92 9.19L17.09 8.36C16.35 7.62 15.05 7.61 14.3 8.36L13.21 9.45L8.65 14.01C8.55 14.11 8.48 14.25 8.44 14.39L7.79 17.6C7.74 17.85 7.82 18.1 8 18.28C8.14 18.42 8.33 18.5 8.53 18.5C8.58 18.5 8.63 18.5 8.68 18.48L11.89 17.83C12.03 17.8 12.17 17.73 12.27 17.63L16.83 13.07L17.92 11.98C18.69 11.21 18.69 9.96 17.92 9.19ZM15.37 9.43C15.55 9.25 15.86 9.25 16.04 9.43L16.87 10.26C17.05 10.44 17.05 10.74 16.87 10.93L16.31 11.49L14.82 10L15.38 9.44L15.37 9.43ZM11.37 16.41L9.5 16.79L9.88 14.92L13.75 11.05L15.24 12.54L11.37 16.41ZM18.5 4.04V6.15C18.5 6.56 18.16 6.9 17.75 6.9C17.34 6.9 17 6.56 17 6.15V4.04C17 3.19 16.31 2.5 15.46 2.5H4.04C3.19 2.5 2.5 3.19 2.5 4.04V15.45C2.5 16.3 3.19 16.99 4.04 16.99H5.65C6.06 16.99 6.4 17.33 6.4 17.74C6.4 18.15 6.06 18.49 5.65 18.49H4.04C2.36 18.49 1 17.12 1 15.45V4.04C1 2.37 2.37 1 4.04 1H15.45C17.13 1 18.49 2.37 18.49 4.04H18.5ZM4.52 5.6C4.52 5.19 4.86 4.85 5.27 4.85H11.47C11.88 4.85 12.22 5.19 12.22 5.6C12.22 6.01 11.88 6.35 11.47 6.35H5.27C4.86 6.35 4.52 6.01 4.52 5.6ZM4.52 8.78C4.52 8.37 4.86 8.03 5.27 8.03H9.96C10.37 8.03 10.71 8.37 10.71 8.78C10.71 9.19 10.37 9.53 9.96 9.53H5.27C4.86 9.53 4.52 9.19 4.52 8.78Z" fill={color} />
    </svg>
);

// More Icon
export const More = ({ color = '#9B96A2', size = 20, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx="10" cy="4" r="2" fill={color} />
        <circle cx="10" cy="16" r="2" fill={color} />
        <circle cx="10" cy="10" r="2" fill={color} />
    </svg>
);

// Plus Icon
export const Plus = ({ color = '#9B96A2', size = 20, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M10 3C10.5523 3 11 3.44772 11 4V9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H11V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V11H4C3.44772 11 3 10.5523 3 10C3 9.44772 3.44772 9 4 9H9V4C9 3.44772 9.44772 3 10 3Z"
            fill={color}
        />
    </svg>
);

// Minus Icon
export const Minus = ({ color = '#9B96A2', size = 20, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <rect x="3" y="9" width="14" height="2" rx="1" fill={color} />
    </svg>
);

// QR Icon
export const QR = ({ color = '#9B96A2', size = 20, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <path
            d="M3 6V3H6M3 14.12V17.12H6M14.33 17.12H17.33V14.12M17.33 6V3H14.33M9.92 5.92H5.92V9.92H9.92V5.92Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M12.8 13.08H10.8V11.08H12.8V13.08ZM14.8 13.08H12.8V15.08H14.8V13.08ZM14.8 9.07996H12.8V11.08H14.8V9.07996ZM10.8 13.08H8.80005V15.08H10.8V13.08Z"
            fill={color}
        />
    </svg>
);

// Camera Icon
export const Camera = ({ color = '#9B96A2', size = 20, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <path
            d="M3.79 17C2.25 17 1 15.74 1 14.21V8.26C1 6.72 2.25 5.47 3.79 5.47H4.98C5.38 5.47 5.73 5.22 5.86 4.84L6.11 4.09C6.33 3.44 6.94 3 7.62 3H12.38C13.07 3 13.67 3.44 13.89 4.09L14.14 4.84C14.27 5.22 14.62 5.47 15.02 5.47H16.21C17.75 5.47 19 6.72 19 8.26V14.21C19 15.75 17.74 17 16.21 17H3.79ZM10.01 7.44C8.13 7.44 6.6 8.98 6.6 10.86C6.6 12.74 8.13 14.28 10.01 14.28C11.89 14.28 13.42 12.74 13.42 10.86C13.42 8.98 11.89 7.44 10.01 7.44ZM15.51 7.82C15.01 7.82 14.6 8.24 14.6 8.73C14.6 9.22 15.01 9.64 15.51 9.64C16.01 9.64 16.42 9.22 16.42 8.73C16.42 8.24 16.01 7.82 15.51 7.82Z"
            fill={color}
        />
    </svg>
);

// Tos Icon
export const Tos = ({ color = '#9B96A2', size = 20, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        {...props}
    >
        <path
            d="M15.46 1H4.04C2.37 1 1 2.37 1 4.04V15.45C1 17.13 2.37 18.49 4.04 18.49H15.45C17.13 18.49 18.49 17.12 18.49 15.45V4.04C18.49 2.36 17.12 1 15.45 1H15.46ZM17 15.46C17 16.31 16.31 17 15.46 17H4.04C3.19 17 2.5 16.31 2.5 15.46V4.04C2.5 3.19 3.19 2.5 4.04 2.5H15.45C16.3 2.5 16.99 3.19 16.99 4.04V15.45L17 15.46ZM15.4 5.4C15.4 5.81 15.06 6.15 14.65 6.15H4.85C4.44 6.15 4.1 5.81 4.1 5.4C4.1 4.99 4.44 4.65 4.85 4.65H14.65C15.06 4.65 15.4 4.99 15.4 5.4ZM15.4 11.2C15.4 11.61 15.06 11.95 14.65 11.95H4.85C4.44 11.95 4.1 11.61 4.1 11.2C4.1 10.79 4.44 10.45 4.85 10.45H14.65C15.06 10.45 15.4 10.79 15.4 11.2ZM15.4 14.1C15.4 14.51 15.06 14.85 14.65 14.85H4.85C4.44 14.85 4.1 14.51 4.1 14.1C4.1 13.69 4.44 13.35 4.85 13.35H14.65C15.06 13.35 15.4 13.69 15.4 14.1ZM15.4 8.3C15.4 8.71 15.06 9.05 14.65 9.05H4.85C4.44 9.05 4.1 8.71 4.1 8.3C4.1 7.89 4.44 7.55 4.85 7.55H14.65C15.06 7.55 15.4 7.89 15.4 8.3Z"
            fill={color}
        />
    </svg>
);

// 모든 아이콘을 하나의 객체로 export
export const Icons = {
    IcAdd,
    IcAlarm,
    IcChange,
    IcEdit,
    IcRight,
    IcSearch,
    Delete,
    Check,
    PendingApproval,
    OrganizationManagement,
    UserManagement,
    DidimHw,
    Contents,
    Championship,
    EventManagement,
    NoticeAndPush,
    GeneralManagement,
    Dashboard,
    StepCount,
    HeartRate,
    DidimActivity,
    Challenge,
    PointIcon,
    RankingIcon,
    BasicInfoIcon,
    Favorite,
    FavoriteCheck,
    Lock,
    Unlock,
    Tournament,
    Ranking,
    Phone,
    Message,
    Visible,
    Invisible,
    Link,
    Union,
    // Button checkbox icons
    BtCheck,
    BtUncheck,
    // Navigation icons
    Back,
    Home,
    Exercise,
    Reward,
    Trophy,
    Setting,
    Point,
    Up,
    Calendar,
    Next,
    Delete1,
    Prev,
    Day,
    Refresh,
    Info,
    Search,
    // Profile icons
    PhotoEmpty,
    // Document icons
    Memo,
    // Action icons
    More,
    Plus,
    Minus,
    // QR icon
    QR,
    // Camera icon
    Camera,
    // Tos icon
    Tos,
};

// Organization Emblem
export { OrganizationEmblem } from './organizationEmblem';

// User Emblem
export { UserEmblem } from './userEmblem';

export default Icons;
